import styled, { css } from "styled-components";

interface ContainerProps {
  borderColor?: string
  bgColor?: string
  showButton?: () => void
  error?: boolean
  disabled?: boolean
  width?: string;
}

interface TextProps {
  fontSize?: string;
  color?: string;
}

interface ButtonProps {
  disabled?: boolean;
  opacity?: string;
  border?: string;
  borderRadius?: string;
  hoverBorder?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const InputContainer = styled.div<ContainerProps>`
  display: flex;
  height: 29px;
  padding-right: .7rem;
  width: ${props => props.width ? props.width : "262px"};
  align-items: center;
  border: 1px solid ${props => props.borderColor};
  border-radius: 2px;
  background-color: ${props => props.bgColor};

  &:hover {
    .button {
      transition: opacity .2s ease-in-out;
      opacity: 1;
    }
  }

  &:focus-within {
    border: 1px solid;
  }

  & input {
    height: 26px;
    border: none;
  }

  ${({ disabled }) => disabled && css`
    background-color: transparent;
    border: none;

    & input {
      background-color: transparent;
    }

    &:hover {
      filter: none;
    }
  `}
`
export const Button = styled.button<ButtonProps>`
  transition: opacity .2s ease-in-out;
  opacity: ${props => props.opacity ? props.opacity : 0};
  border: ${props => props.border ? props.border : ""};
  border-radius: ${props => props.borderRadius ? props.borderRadius: ""};

  ${({ disabled }) => disabled && css`
    cursor: not-allowed;
  `}

  ${({ hoverBorder }) => hoverBorder && css`

    &:hover {
      border: 1px solid #D9D9D9;
      transition: all .2s ease-in;
    }
  `}
`
export const Text = styled.span<TextProps>`
  color: ${props => props.color ? props.color : "#000"};
  font-size: ${props => props.fontSize ? props.fontSize : "16px"};
`